"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var TWHorizontalScroll_1 = require("../classes/TWHorizontalScroll");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var FeaturesSection = /** @class */ (function () {
    function FeaturesSection() {
    }
    FeaturesSection.prototype.onLoadEach = function ($element) {
        (0, rxjs_1.timer)(500)
            .pipe((0, operators_1.take)(1))
            .subscribe(function () { return new TWHorizontalScroll_1["default"]($element); });
    };
    FeaturesSection = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".HorizontalScrollSection",
            isElementArray: true
        })
    ], FeaturesSection);
    return FeaturesSection;
}());
new FeaturesSection();
